import { render, staticRenderFns } from "./tncConfiguration.vue?vue&type=template&id=3dcf2e7c&"
import script from "./tncConfiguration.vue?vue&type=script&lang=js&"
export * from "./tncConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./tncConfiguration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dcf2e7c')) {
      api.createRecord('3dcf2e7c', component.options)
    } else {
      api.reload('3dcf2e7c', component.options)
    }
    module.hot.accept("./tncConfiguration.vue?vue&type=template&id=3dcf2e7c&", function () {
      api.rerender('3dcf2e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/apps/tncConfiguration.vue"
export default component.exports